import React, { Component } from "react";
import { getStaticText } from '../../../lables/lablesService';
import AboutUsPosts from '../api/about-us-posts';
import ImageInput from '../../../components/image-input-component/imageInput';
import HtmlInput from '../../../components/html-input-component/htmlInput';


class RecordsForm extends Component {

	constructor(props) {
        super(props);

        this.save_type_process = false;
        this.state = {
        	'increment' : 0
        };
    }


    changePostInfo ( prop_name, prop_value ) {
    	let value = null;
        switch (prop_name) {
            case 'content':
                    value = prop_value;
                break;

            case 'active':
                    value = prop_value.target.checked ? 1 : 0;
                break;

            default:
                    value = prop_value.target.value
                break;
        }
        this.props.post_info[prop_name] = value;
    }


    changePostImage ( image_name, image ) {
    	this.props.post_info.image_name = image_name;
        this.props.post_info.image = image;
        this.setState({
            'increment' : this.state.increment + 1
        });
    }


    async savePost () {
    	if ( this.save_type_process )
            return false;

        this.save_type_process = true;

        const formData = new FormData();

        if ( this.props.post_info.id > 0 )
            formData.append( 'id', this.props.post_info.id );

        if ( typeof(this.props.post_info.image) === 'object' )
            formData.append( 'image', this.props.post_info.image );

        formData.append( 'title', this.props.post_info.title );
        formData.append( 'content', this.props.post_info.content );
        formData.append( 'type_id', this.props.post_info.type_id );
        formData.append( 'position', this.props.post_info.position );
        formData.append( 'active', this.props.post_info.active );

        let result = null;
        if ( this.props.post_info.id === 0 )
            result = await AboutUsPosts.add( formData );
        else
            result = await AboutUsPosts.update( formData );
    
        if ( !result ) {
            window.alert( getStaticText('save_error') );
        } else {
            window.alert( getStaticText('save_success') );
            if ( typeof(this.props.formCallback) === 'function' )
            	this.props.formCallback();
        }
        
        this.save_type_process = false;
    }


	render () {
		let types_for_select = [];
		types_for_select.push(<option key="aup_type_id_opt_0" value={0}>{getStaticText('aup_form_type_id_empty_opt')}</option>);
		for ( let id in this.props.post_types ) {
			types_for_select.push(<option key={"aup_type_id_opt_" + id} value={id}>{this.props.post_types[id]}</option>);
		}

		return (<>
				<ImageInput 
                    label={getStaticText('aup_form_image_input_label')}
                    fileImage={this.props.post_info.image || null}
                    fileName={this.props.post_info.image_name || null}
                    handleFile={this.changePostImage.bind(this)}
                />

                <div className="form-group">
                    <label
                        htmlFor="aupTitleInput"
                    >
                        {getStaticText('aup_form_title_input_label')}
                    </label>
                    <input 
                        id="aupTitleInput"
                        className="form-control"
                        defaultValue={this.props.post_info.title}
                        onChange={this.changePostInfo.bind(this, 'title')}
                    />
                </div>

                <div className="form-group">
                    <label
                        htmlFor="aupTypeIdInput"
                    >
                        {getStaticText('aup_form_type_id_input_label')}
                    </label>
                    <select 
                        id="aupTypeIdInput"
                        className="form-control"
                        defaultValue={this.props.post_info.type_id}
                        onChange={this.changePostInfo.bind(this, 'type_id')}
                    >
                    	{types_for_select}
                    </select>
                </div>

                <HtmlInput 
                    label={getStaticText('aup_form_content_input_label')}
                    content={this.props.post_info.content}
                    inputName="content"
                    onChangeContent={this.changePostInfo.bind(this)}
                />

                <div className="form-group">
                    <label
                        htmlFor="aupPositionInput"
                    >
                        {getStaticText('aup_form_position_input_label')}
                    </label>
                    <input 
                        id="aupPositionInput"
                        className="form-control"
                        defaultValue={this.props.post_info.position}
                        onChange={this.changePostInfo.bind(this, 'position')}
                    />
                </div>

                <div className="form-group">
                    <label>
                        <input 
                            type="checkbox"
                            defaultChecked={this.props.post_info.active}
                            onChange={this.changePostInfo.bind(this, 'active')}
                        /> {getStaticText('aup_form_active_input_label')}
                    </label>
                </div>

                <div className="form-group os-text-right">
                    <button
                        className="btn btn-success"
                        onClick={this.savePost.bind(this)}
                    >
                        {this.props.post_info.id ? getStaticText('aup_form_update_button_label') : getStaticText('aup_form_add_button_label')}
                    </button>
                </div>
			</>);
	}
}


export default RecordsForm;